import { makeStyles } from '@material-ui/core';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { calculateHeight, calculateWidth, rem, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const useStyles = makeStyles(() => ({
  dialogPaper: {
    borderRadius: 2,
    backgroundColor: themeColor.lightBackground,
    color: themeColor.defaultTextColor,
    border: `1px solid ${themeColor.secondaryLight}`,
  },
  dialogPaperFullWidth: {
    maxWidth: calculateWidth(884).stringValue,
  },
  header: {
    backgroundColor: themeColor.white,
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
    padding: `${calculateHeight(18).stringValue} ${calculateWidth(20).stringValue}`,
  },
  headerTitle: {
    flex: 1,
  },
  statusIcon: {
    height: CashierPreferencesHelper.textSizeScalar() * 24,
    width: CashierPreferencesHelper.textSizeScalar() * 24,
  },
  contentContainer: {
    padding: `${calculateHeight(39).stringValue} 0 ${calculateWidth(20).stringValue}`,
    flex: 1,
  },
  bottomRow: {
    paddingTop: calculateHeight(13).stringValue,
  },
  leftColumn: {
    maxWidth: calculateWidth(346).stringValue,
  },
  rightColumn: {
    flex: 1,
  },
  deviceListContainer: {
    paddingLeft: calculateWidth(30).stringValue,
    paddingRight: calculateWidth(30).stringValue,
    height: calculateHeight(416).stringValue,
    borderRight: `1px solid ${themeColor.defaultTextColor}33`,
  },
  deviceList: {
    width: '100%',
  },
  pagination: {
    width: calculateWidth(112).stringValue,
  },
  actionButtons: {
    paddingRight: calculateWidth(20).stringValue,
  },
  bar: {
    marginTop: calculateHeight(15).stringValue,
    marginBottom: calculateHeight(100).stringValue,
  },
  closeButton: {
    padding: `${calculateHeight(16).stringValue} ${calculateWidth(43).stringValue}`,
    fontSize: rem(1),
  },
  healthButton: {
    padding: `${calculateHeight(16).stringValue} ${calculateWidth(43).stringValue}`,
    fontSize: rem(1),
  },
  connectButton: {
    padding: `${calculateHeight(16).stringValue} ${calculateWidth(78).stringValue}`,
    fontSize: rem(1),
    marginTop: calculateHeight(23).stringValue,
  },
  messageSubtitle: {
    color: themeColor.palesky,
    marginTop: calculateHeight(11).stringValue,
    padding: `0 ${calculateWidth(35).stringValue}`,
  },
  messageContainer: {
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `0 ${calculateWidth(50).stringValue}`,
  },
  messageLineStatus: {
    color: themeColor.blackish,
  },
  noOverflow: {
    display: '-webkit-box',
    overflow: 'hidden',
    wordBreak: 'break-word',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
  deviceItem: {
    padding: '4vh 3vh',
    height: '10px',
    width: vw(46.875),
    alignSelf: 'center',
    flexGrow: 2,
  },
  deviceName: {
    textAlign: 'right',
    maxWidth: '45%',
    flexGrow: 1,
  },
  deviceStatus: {
    maxWidth: '45%',
  },
  messageDivider: {
    columnGap: '1rem',
  },
  healthCheckHeader: {
    flex: 1,
    paddingTop: 25,
    alignContent: 'center',
  },
  healthButtonContainer: {
    paddingRight: calculateWidth(30).stringValue,
  },
}));
